module.exports = [
  'appnexus',
  'appnexus-ios-id',
  'appnexus-test',
  'eyeota',
  'eyeota-test',
  'liveramp',
  'liveramp-android-id',
  'liveramp-international',
  'liveramp-ios-id',
  'liveramp-us',
  'liveramp-us-test',
  'lotame',
  'nielsen-de',
  'nielsen-de-test',
  'nielsen-eu',
  'nielsen-eu-test',
  'nielsen-gb',
  'nielsen-us',
  'oracle',
  'owneriq',
  'rocketfuel',
  'rtbiq',
  'test',
  'trusignal',
  'ttd',
  'ttd-test',
]
